import { Link } from 'react-router-dom';

/** Port of Pages/Account/AccessDenied.cshtml. */
export function AccessDeniedPage() {
  return (
    <div className="card shadow-sm border-0">
      <div className="card-body p-4 text-center">
        <i className="bi bi-shield-lock text-danger" style={{ fontSize: '2.5rem' }} />
        <h5 className="fw-semibold mt-3 mb-1">Access denied</h5>
        <p className="text-body-secondary small mb-4">
          Your account does not have permission to view that page.
        </p>
        <Link to="/dashboard" className="btn btn-primary btn-sm">
          <i className="bi bi-arrow-left me-1" /> Back to dashboard
        </Link>
      </div>
    </div>
  );
}

/** Port of Pages/StatusCode.cshtml for the 404 case. */
export function NotFoundPage() {
  return (
    <div className="card shadow-sm border-0">
      <div className="card-body p-4 text-center">
        <i className="bi bi-question-circle text-body-secondary" style={{ fontSize: '2.5rem' }} />
        <h5 className="fw-semibold mt-3 mb-1">Page not found</h5>
        <p className="text-body-secondary small mb-4">
          The page you are looking for does not exist or has moved.
        </p>
        <Link to="/dashboard" className="btn btn-primary btn-sm">
          <i className="bi bi-arrow-left me-1" /> Back to dashboard
        </Link>
      </div>
    </div>
  );
}
